export class PlatformError extends Error {
  showMessage: boolean

  constructor(message: string | undefined, options: { showMessage: boolean }) {
    super(message)
    this.showMessage = options?.showMessage
  }
}
